// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-signature-js": () => import("./../../../src/templates/signature.js" /* webpackChunkName: "component---src-templates-signature-js" */)
}

